import { Outlet } from "react-router";
import { MainTemplate } from "../components/template/MainTemplate";

export const MainPage = () => {
  return (
    <MainTemplate>
      <Outlet />
    </MainTemplate>
  );
};
